<template>
  <div class="main-doctor">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <h1 class="title-pages">FILIAL - TRANSFERÊNCIA DE RESIDENTE</h1>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-2">
          <div class="row">
            <div class="col-md-4">
              <label>RESIDENTES ATIVO/INATIVO</label>
              <select
                v-model="status_resident"
                class="form-control"
                @change="handleChangeStatusResident"
              >
                <option :value="null">TODOS</option>
                <option value="ATIVO">ATIVO</option>
                <option value="INATIVO">INATIVO</option>
              </select>
            </div>
            <div class="col-md-4">
              <label>RESIDENTE</label>
              <select v-model="resident_id" class="form-control">
                <option value="">SELECIONE...</option>
                <option
                  v-for="resident in residents"
                  :key="resident.id"
                  :value="resident.id"
                >
                  {{ resident.name }}
                  {{
                    resident.already_transferred == 1
                      ? "(Já foi feito transferência)"
                      : ""
                  }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label>FILIAL</label>
              <select v-model="rest_home_id" class="form-control">
                <option value="">SELECIONE...</option>
                <option
                  v-for="rest_home in resthomes"
                  :key="rest_home.id"
                  :value="rest_home.id"
                >
                  {{ rest_home.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="mt-2">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="mt-2 text-right">
            <confirmation-dialog
              :disabled="btnDisabled"
              header-class="modal-header"
              message-title="Deseja realmente solicitar a transferência do residente para a FILIAL selecionada?"
              message-body="Ao confirmar, não é possível reverter o processo."
              open-class="btn-save"
              open-left-icon="fa-exchange-alt"
              open-text="SOLICITAR TRANSFERÊNCIA"
              @yes="transfer"
            />
          </div>
        </div>
        <div class="mt-5 text-center">
          <button class="btn btn-save" :disabled="loading" @click="retrieve">
            <i class="fas fa-sync-alt"></i> ATUALIZAR
          </button>
        </div>
        <div class="mt-2 border p-2 bg-white">
          <h1 class="title">Solicitações enviadas</h1>
          <div
            class="v-clean p-5 text-center"
            v-show="residentsToRequestTransfer.length == 0"
          >
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            v-show="residentsToRequestTransfer.length > 0"
            :headers="headers"
            :items="residentsToRequestTransfer"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="clickRowTable"
          >
            <template v-slot:[`item.status`]="{ item }">
              <span
                class="badge badge-secondary"
                v-if="item.transfer_request == 'PENDENTE'"
                >PENDENTE</span
              >
              <span
                class="badge badge-danger"
                v-if="item.transfer_request == 'NEGADO'"
                >NEGADO</span
              >
            </template>
            <template v-slot:[`item.resident`]="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:[`item.rest_home`]="{ item }">
              {{ item.transfer_rest_home.name }}
              <span
                v-if="
                  item.transfer_rest_home.cnpj &&
                  item.transfer_rest_home.cnpj != 0
                "
              >
                / {{ item.transfer_rest_home.cnpj }}
              </span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <confirmation-dialog
                message-title="CANCELAR SOLICITAÇÃO?"
                x_small
                message-body="Deseja realmente cancelar a solicitação de transferência?"
                open-class="btn-delete"
                open-left-icon="fa-trash"
                open-text="CANCELAR"
                @yes="deleteRequestTransfer(item.id)"
              />
            </template>
          </v-data-table>
        </div>
        <div class="mt-2 border p-2 bg-white">
          <h1 class="title">Solicitações recebidas</h1>
          <div class="mt-2">
            <ErrorsMessages :errors="errorsRefuse" />
            <ErrorsMessages :errors="errorsAccept" />
          </div>
          <div
            class="v-clean p-5 text-center"
            v-show="residentsToAcceptTransfer.length == 0"
          >
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            v-show="residentsToAcceptTransfer.length > 0"
            :headers="headers"
            :items="residentsToAcceptTransfer"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="clickRowTable"
          >
            <template v-slot:[`item.status`]="{ item }">
              <span
                class="badge badge-warning"
                v-if="item.transfer_request == 'PENDENTE'"
                >PENDENTE</span
              >
              <span
                class="badge badge-danger"
                v-if="item.transfer_request == 'NEGADO'"
                >NEGADO</span
              >
            </template>
            <template v-slot:[`item.resident`]="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:[`item.rest_home`]="{ item }">
              {{ item.request_rest_home.name }}
              <span
                v-if="
                  item.request_rest_home.cnpj &&
                  item.request_rest_home.cnpj != 0
                "
              >
                / {{ item.request_rest_home.cnpj }}
              </span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <confirmation-dialog
                message-title="NEGAR SOLICITAÇÃO?"
                x_small
                message-body="Deseja realmente negar a solicitação de transferência?"
                open-class="btn-delete m-1"
                open-left-icon="fa-times"
                open-text="NEGAR"
                @yes="refuseRequestTransfer(item.id)"
              />
              <b-modal
                title="CONFIRMAÇÃO"
                :id="`acceptRequestTransfer-${item.id}`"
                hide-footer
                hide-header-close
                no-close-on-backdrop
                no-close-on-esc
                centered
                header-class="modal-header-ok"
              >
                <div class="row">
                  <div class="col-md-12">
                    <h6 class="upper-text text-eighteen color-blackfor">
                      O QUE DESEJA TRANSFERIR?
                    </h6>
                    <p class="worksansr">
                      Selecione abaixo as informações que você deseja transferir
                      para a filial:
                      <strong>{{ item.request_rest_home.name }}</strong>
                    </p>
                    <p class="worksansr">
                      Por padrão já vai os dados cadastrais do residente!
                    </p>
                  </div>
                  <div class="col-md-12">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="care"
                        id="care"
                        v-model="care"
                      />
                      <label class="form-check-label" for="care">
                        ANOTAÇÃO DE CUIDADOS
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="care_vital_signs"
                        id="care_vital_signs"
                        v-model="care_vital_signs"
                      />
                      <label class="form-check-label" for="care_vital_signs">
                        SINAIS VITAIS
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="order"
                        id="order"
                        v-model="order"
                      />
                      <label class="form-check-label" for="order">
                        PEDIDOS DIVERSOS
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="evolution"
                        id="evolution"
                        v-model="evolution"
                      />
                      <label class="form-check-label" for="evolution">
                        EVOLUÇÕES
                      </label>
                    </div>
                  </div>
                </div>
                <b-row align-h="between" no-gutters>
                  <b-col cols="auto">
                    <v-btn
                      :disabled="loading"
                      :loading="loading"
                      class="worksansr btn-cancel"
                      @click="$bvModal.hide(`acceptRequestTransfer-${item.id}`)"
                    >
                      CANCELAR
                    </v-btn>
                  </b-col>
                  <b-col cols="auto">
                    <v-btn
                      :disabled="loading"
                      :loading="loading"
                      class="worksansr btn-save"
                      @click="acceptRequestTransfer(item.id)"
                    >
                      TRANSFERIR
                    </v-btn>
                  </b-col>
                </b-row>
              </b-modal>
              <v-btn
                x-small
                @click="$bvModal.show(`acceptRequestTransfer-${item.id}`)"
                class="btn-save"
              >
                <i class="fas fa-check mr-2"></i>ACEITAR
              </v-btn>
            </template>
          </v-data-table>
        </div>
        <div class="mt-2">
          <div>
            <v-alert
              border="bottom"
              colored-border
              type="warning"
              elevation="2"
            >
              Após aceitar a solicitação, não poderá reverter o processo.
            </v-alert>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar.vue";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired.vue";

import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

import ConfirmationDialog from "../templates/Components/ConfirmationDialog.vue";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "Branch",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      status_resident: "ATIVO",

      residentsToAcceptTransfer: [],
      residentsToRequestTransfer: [],

      headers: [
        { text: "STATUS", sortable: false, value: "status" },
        { text: "RESIDENTE", sortable: false, value: "resident" },
        { text: "FILIAL", sortable: false, value: "rest_home" },
        { text: "", sortable: false, value: "action" },
      ],

      residents: [],
      resident_id: "",

      resthomes: [],
      rest_home_id: "",

      care: false,
      care_vital_signs: false,
      order: false,
      evolution: false,

      errors: [],
      errorsAccept: [],
      errorsRefuse: [],
      loading: false,
    };
  },

  computed: {
    btnDisabled() {
      let { loading, resident_id, rest_home_id } = this;

      if (loading) return true;
      if (!resident_id) return true;
      if (!rest_home_id) return true;

      return false;
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    clickRowTable({ id }) {
      id;
    },

    handleChangeStatusResident() {
      this.residents = [];
      this.resident_id = "";
      this.getResidents();
    },

    retrieve() {
      this.errors = [];
      this.errorsAccept = [];
      this.errorsRefuse = [];

      this.getResidents();
      this.getResidentsToRequestTransfer();
      this.getResidentsToAcceptTransfer();
      this.getRestHomes();
    },

    async getResidents() {
      try {
        this.loading = true;

        let { status_resident } = this;

        let params = { status_resident };

        const response = await api.get("/branch/residents-to-transfer", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidentsToRequestTransfer() {
      try {
        this.loading = true;

        const response = await api.get("/branch/residents-to-request-transfer");

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residentsToRequestTransfer = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidentsToAcceptTransfer() {
      try {
        this.loading = true;

        const response = await api.get("/branch/residents-to-accept-transfer");

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residentsToAcceptTransfer = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getRestHomes() {
      try {
        this.loading = true;

        const response = await api.get("/resthomes");

        const { error, errors, resthomes } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.resthomes = resthomes;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async transfer() {
      try {
        this.loading = true;

        let { resident_id, rest_home_id } = this;

        let data = { resident_id, rest_home_id };

        let response = await api.post("/branch/request-transfer", data);

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.resident_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async deleteRequestTransfer(id) {
      try {
        this.loading = true;

        let data = { id };

        let response = await api.put("/branch/cancel-request-transfer", data);

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.resident_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async acceptRequestTransfer(id) {
      try {
        this.loading = true;
        this.errors = [];
        this.errorsAccept = [];
        this.errorsRefuse = [];

        let { care, care_vital_signs, order, evolution } = this;

        let data = { id, care, care_vital_signs, order, evolution };

        let response = await api.put("/branch/accept-request-transfer", data);

        let { error, errors, message } = response.data;

        if (error) {
          this.errorsAccept = errors;
        } else {
          this.errorsAccept = [];
          toast(message, "success");
          this.$bvModal.hide(`acceptRequestTransfer-${id}`);
          this.resident_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async refuseRequestTransfer(id) {
      try {
        this.loading = true;
        this.errors = [];
        this.errorsAccept = [];
        this.errorsRefuse = [];

        let data = { id };

        let response = await api.put("/branch/refuse-request-transfer", data);

        let { error, errors, message } = response.data;

        if (error) {
          this.errorsRefuse = errors;
        } else {
          this.errorsRefuse = [];
          toast(message, "success");
          this.resident_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.main-doctor .photo-url {
  width: 25px;
  height: 25px;
  object-fit: cover !important;
  border-radius: 100%;
}
</style>